// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"184":"f233efdee322644f","541":"944ffd5c8c0200da"}[chunkId] + ".js";
};